import { render, staticRenderFns } from "./DraftCarManager.vue?vue&type=template&id=4603fc72"
import script from "./DraftCarManager.vue?vue&type=script&lang=js"
export * from "./DraftCarManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports